<template>
  <el-card>
    <div>
      <el-button size="small" icon="el-icon-arrow-left" @click="returnlist">返回列表</el-button>
      <el-form
        style="margin-top:30px;"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item  label="上线时间 " prop="actionStartTime">
          <el-date-picker
            v-model="da1"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            :unlink-panels="true"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="简介" prop="title">
          <el-input :rows="4"  type="textarea" v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content" >
          <quill-editor
           
            v-model="ruleForm.content"
            ref="myQuillEditor"
            class="editor"
            :options="editorOption"
            @change="onEditorChange($event)"
            @ready="onEditorReady($event)"
          ></quill-editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import qs from "qs";

export default {
  components: {
    quillEditor
  },
  data() {
    return {
      da1: [],
      ruleForm: {},
      rules: {},
      imageUrl: "",
      inputVisible: false,
      inputValue: "",
      tags: ["标签一"],
      detailContent: "", // 富文本内容
      editorOption: {}, // 富文本编辑器配置
      videoList: [
        {
          id: 0,
          videoSrc: require("../../../assets/video/01.mp4")
        }
      ]
    };
  },
  methods: {
    submitForm: function() {
      this.ruleForm.actionStartTime = this.da1[0];
      this.ruleForm.actionEndTime = this.da1[1];
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          var res = await this.$http.post(
            `/v1/notice/addoredit`,
            this.ruleForm
          );
          var { code, data, message } = res.data;
          if (code == 0) {
            this.$router.push(`/notice`);
            this.$message.success("添加/编辑成功");
          } else {
            this.$message.error(message);
          }
        }
      });
    },
    getinfo: async function() {
      var id = this.$route.query.id;
      if (id != undefined && id != "" && id != null) {
        var res = await this.$http.get(`/v1/notice/getNotice?id=${id}`);
        var { code, message, data } = res.data;
        if (code == 0) {
          this.ruleForm = data;
          this.detailContent = data.content;
          this.da1 = [data.actionStartTime,data.actionEndTime];
        }
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onEditorReady(instance) {
      // instance.setContent("");
      // instance.addListener("contentChange", () => {
      //   this.content = instance.getContent();
      // });
    },
    onEditorChange(event) {
      // console.log(event);
    },
    changetime() {
      console.log(this.ruleForm.actionStartTime);
    },
    returnlist: function() {
      this.$router.push(`/notice`);
    }
  },
  mounted() {
    this.getinfo();
  }
};
</script>

<style>
.editor .ql-toolbar.ql-snow + .ql-container.ql-snow{
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/notice-mg/noticeadd.vue